import dayjs, { Dayjs } from "dayjs";
import { FormikValues } from "formik";

export {};
export interface Application {
  id: string;
  dateFrom: Date;
  dateTo: Date;
  reason: string;
  function: string;
  locations: string[];
  department: {
    name: string;
  };
  applicant: {
    firstName: string;
    lastName: string;
    birthDay: Date;
    birthPlace: string;
    nationality: string;
    rrn: string;
    email: string;
    address: {
      street: string;
      houseNumber: string;
      box: string;
      zip: string;
      city: string;
      country: string;
    };
    company: {
      name: string;
    };
  };
  responsible: {
    firstName: string;
    lastName: string;
    email: string;
    company: {
      name: string;
    };
  };
  tenantId?: string;
}

export function convertFormikToApplication(
  applicationId: string | undefined,
  values: FormikValues
): Application {
  // console.log(values);
  return {
    id: applicationId as string,
    dateFrom: values.dateFrom,
    dateTo: values.dateTo,
    reason: values.reason,
    function: values.function,
    locations: values.locations,
    department: {
        name: values.userDepartment,
    },
    applicant: {
      firstName: values.userFirstName,
      lastName: values.userLastName,
      birthDay: values.userBirthDay,
      birthPlace: values.userBirthPlace,
      nationality: values.userNationality,
      rrn: values.userRRN,
      email: values.userEmail,
      address: {
        street: values.userAddressStreet,
        houseNumber: values.userAddressHouseNumber,
        box: values.userAddressBox,
        zip: values.userAddressZip,
        city: values.userAddressCity,
        country: values.userAddressCountry,
      },
      company: {
        name: values.companyName,
      },
    },
    responsible: {
      firstName: values.companyResponsibleFirstName,
      lastName: values.companyResponsibleLastName,
      email: values.companyResponsibleEmail,
      company: {
        name: values.companyName,
      },
    },
    tenantId: values.zone
  };
}

export function convertFormikToApplicationWithDetails(
  applicationId: string | undefined,
  values: FormikValues
): ApplicationWithDetails | any {
  const data: any = {
    id: applicationId as string,
    dateFrom: values.dateFrom,
    dateTo: values.dateTo,
    reason: values.reason,
    function: values.function,
    department: {
      name: values.userDepartment,
    },
    locations: values.locations.map((loc: string) => {
        return {name: loc}
    }),
    applicant: {
      firstName: values.userFirstName,
      lastName: values.userLastName,
      birthPlace: values.userBirthPlace,
      nationality: values.userNationality,
      rrn: values.userRRN,
      email: values.userEmail,
      address: {
        street: values.userAddressStreet,
        houseNumber: values.userAddressHouseNumber,
        box: values.userAddressBox,
        zip: values.userAddressZip,
        city: values.userAddressCity,
        country: values.userAddressCountry,
      },
      company: {
        name: values.companyName,
      },
    },
    responsible: {
      firstName: values.companyResponsibleFirstName,
      lastName: values.companyResponsibleLastName,
      email: values.companyResponsibleEmail,
      company: {
        name: values.companyName,
      },
    },
  }
  if (values.userBirthDay !== '') data.applicant.birthDay = values.userBirthDay;
  return data;
}

const handleParseInt = (value: string): number => {
    const val = parseInt(value);
    console.log(val, value)
    if (val !== null && val !== undefined && !Number.isNaN(val)) return val;
    return 0;
}